export default { options: { label: 'Matchevents Collections' } }
